import type { FC } from 'react'

import { Td } from '@skytech/ui/Table/Td'
import { companyNamesByWhiteLabelId } from '@skytech/utils'
import { useSelector } from 'react-redux'
import { Link } from 'react-router-dom'

import { Translation } from '@/components/i18n/Translation'
import { TrLink } from '@/components/TrLink'
import Highlight from '@/components/util/Highlight'
import { getTextFilter } from '@/ducks/customersReducer'
import { useIsBechtle } from '@/hooks/user'
import { numberFormat } from '@/util/formatters/numbers'
import { appRoutes } from '@/util/misc'

const CustomerListItem: FC<any> = ({
  id,
  name,
  orgNumber,
  vatNumber,
  numberOfEmployees,
  address1,
  address2,
  zip,
  city,
  customerHeadName,
  customerStatus,
  whitelabel_id,
  whitelabelName,
  is_subscription_dealer,
}) => {
  const textFilter = useSelector(getTextFilter)
  const isBechtle = useIsBechtle()

  const baseLink = appRoutes.customer.replace(':customer_id', id)
  const customerLink = !is_subscription_dealer ? baseLink.concat('/frame-agreement') : baseLink
  const whitelabelDisplayName = whitelabelName || companyNamesByWhiteLabelId[whitelabel_id]

  return (
    <TrLink path={customerLink}>
      {!isBechtle && (
        <Td>
          <Highlight pattern={textFilter} text={customerHeadName} />
        </Td>
      )}

      <Td>
        <Link to={appRoutes.customer.replace(':customer_id', id)}>
          <Highlight pattern={textFilter} text={name} />
        </Link>
      </Td>

      <Td className="hidden sm:table-cell">
        <Highlight pattern={textFilter} text={orgNumber} />
      </Td>

      <Td className="hidden sm:table-cell">
        <Highlight pattern={textFilter} text={whitelabelDisplayName} />
      </Td>

      <Td className="hidden sm:table-cell">
        <Translation id={`CUSTOMER_STATUS/${customerStatus}`} />
      </Td>

      {isBechtle && (
        <Td className="hidden sm:table-cell">
          <Highlight pattern={textFilter} text={vatNumber} />
        </Td>
      )}
      <Td className="hidden sm:table-cell">
        <div>
          <Highlight pattern={textFilter} text={address1} />
        </div>

        {address2 && (
          <div>
            <Highlight pattern={textFilter} text={address2} />
          </div>
        )}

        <div>
          <Highlight pattern={textFilter} text={zip} />,
          <Highlight pattern={textFilter} text={' ' + city} />
        </div>
      </Td>

      {isBechtle && (
        <Td className="hidden text-right sm:table-cell">
          {numberOfEmployees && numberFormat(numberOfEmployees)}
        </Td>
      )}

      {!isBechtle && (
        <Td className="hidden sm:table-cell">
          <Highlight pattern={textFilter} text={zip} />,{' '}
          <Highlight pattern={textFilter} text={city} />
        </Td>
      )}
    </TrLink>
  )
}

export default CustomerListItem
